import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';

import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';

import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';

import { Inline, Text } from '@atlaskit/primitives/compiled';

const messages = defineMessages({
	previousButtonLabel: {
		id: 'post-office.adminhub-inbox-recommendation.pagination-prev',
		defaultMessage: 'Previous',
		description: 'Label for icon button to go to previous message in pagination',
	},
	nextButtonLabel: {
		id: 'post-office.adminhub-inbox-recommendation.pagination-next',
		defaultMessage: 'Next',
		description: 'Label for icon button to go to next message in pagination',
	},
	pageCountLabel: {
		id: 'post-office.adminhub-inbox-recommendation.pagination-messages',
		defaultMessage: '{count} of {total}',
		description: 'Current and total message count in pagination',
	},
});

export interface PaginationProps {
	currentIndex: number;
	totalItems: number;
	isPrevDisabled: boolean;
	isNextDisabled: boolean;
	handlePrev(): void;
	handleNext(): void;
	isCompact: boolean;
}

export const Pagination: React.FC<PaginationProps> = ({
	currentIndex,
	totalItems,
	isPrevDisabled,
	isNextDisabled,
	handlePrev,
	handleNext,
	isCompact,
}) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.100" alignBlock="center">
			<IconButton
				icon={(iconProps) => (
					<ChevronLeftIcon {...iconProps} size="small" testId="pagination-previous-icon" />
				)}
				label={formatMessage(messages.previousButtonLabel)}
				onClick={handlePrev}
				isDisabled={isPrevDisabled}
				appearance={isCompact ? 'subtle' : 'default'}
			/>
			<Text>
				{formatMessage(messages.pageCountLabel, {
					count: currentIndex + 1,
					total: totalItems,
				})}
			</Text>
			<IconButton
				icon={(iconProps) => (
					<ChevronRightIcon {...iconProps} size="small" testId="pagination-next-icon" />
				)}
				label={formatMessage(messages.nextButtonLabel)}
				onClick={handleNext}
				isDisabled={isNextDisabled}
				appearance={isCompact ? 'subtle' : 'default'}
			/>
		</Inline>
	);
};
